import { getBorderCSS, getColorsCSS, getMultiShadowCSS, getSpaceCSS, getTypoCSS } from '../../Components/Helper/getCSS';

const Style = ({ attributes, clientId }) => {
	const { isFullWidth, addCSS, alignment, typography, colors, hovColors, padding, border, shadow } = attributes;

	return <>
		<style dangerouslySetInnerHTML={{
			__html: `
			${getTypoCSS(typography)?.googleFontLink}

			#btnButton-${clientId}{
				text-align: ${alignment};
			}
			#btnButton-${clientId} .btnButton{
				${getTypoCSS(typography)?.styles || 'font-size: 18px; font-weight: 600; text-decoration: none;'}
				${getColorsCSS(colors) || 'color: #fff; background-color: #4527a4;'}
				width: ${isFullWidth ? '100%' : 'auto'};
				padding: ${getSpaceCSS(padding) || '10px 20px'};
				${getBorderCSS(border) || 'border-radius: 5px;'}
				box-shadow: ${getMultiShadowCSS(shadow?.shadow || shadow) || 'none'};
			}
			#btnButton-${clientId} .btnButton:hover{
				${getColorsCSS(hovColors) || 'color: #fff; background-color: #8344c5;'}
			}
			${addCSS}
			`.replace(/\s+/g, ' ')
		}} />
	</>;
}
export default Style;